export default __webpack_public_path__ + "static/media/ModernEra-Light.b83ede4e.woff";